import React, { Component } from "react";

const CodigoDistribucion = (props) => {
    return (
        <div className="col-xs-12">
            <div className="row bottom-separator-xs">
                <div className="col-xs-12">
                    <div className="row">
                        <div className="col-xs-12">
                            <label className="label-primary">Código de Distribución</label>
                        </div>
                    </div>
                    <label className="label-secondary" >{(props.tarjeta.DistribucionCodigoDescripcion || "Sin especificar")}</label>
                </div>
            </div>
        </div>
    );
}

export default CodigoDistribucion;